import axios from 'axios';
import { domainName } from '@/utils/domainName'
// 设置默认配置
const instance = axios.create({
    baseURL: 'https://ocpc.baidu.com/ocpcapi/api', // 根据实际情况修改base URL
});

export function get(url) {
    return new Promise((resolve, reject) => {
        instance.get(url).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

export function post(url, data) {
    return new Promise((resolve, reject) => {
        instance.post(url, data).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

// ... 这里还可以添加更多HTTP请求方法的封装，如put、delete等

export default {
    get,
    post,
};